import { useAppSelector } from 'app/state'
import HomeOnboardingWelcome from './HomeOnboardingWelcome'
import BasicPage from 'features/common/ui/BasicPage/BasicPage'
import BasicPageContainer from 'features/common/ui/BasicPage/BasicPageContainer'
import HomeBlogLatestPosts from '../HomeBlog/HomeBlogLatestPosts'
import HomeDatasets from '../HomeDatasets/HomeDatasets'
import HomeApps from '../HomeApps/HomeApps'
import { Video } from 'features/onboarding-checklist/types'
import OnboardingInitialDialog from 'features/onboarding-checklist/ui/OnboardingInitialDialog'
import { useEffect, useState } from 'react'
import { OnboardingAction } from 'features/onboarding-checklist/utils/useOnboardingChecklist'
import { useCartoDW, useConnections } from 'features/connections/hooks/connectionsHooks'
import HomeGettingStartedNoCDW from './HomeGettingStartedNoCDW'
import HomeGettingStarted from './HomeGettingStarted'

export function HomeOnboarding({ hasMaps, latestMaps, hasWorkflows, latestWorkflows }) {
  const onboardingVideos = useAppSelector((state) => state.onboardingChecklist.videos)
  const [showInitialDialog, setShowInitialDialog] = useState(false)
  const { isAvailable } = useCartoDW()
  const { data: connections } = useConnections()

  useEffect(() => {
    if (onboardingVideos) {
      const workspaceVideo = onboardingVideos.find((video) => video.id === OnboardingAction.WatchWorkspaceVideo)
      if (!workspaceVideo) return
      setShowInitialDialog(!workspaceVideo?.completed)
    }
  }, [onboardingVideos])

  const hideInitialDialog = () => setShowInitialDialog(false)

  const recentDatasets = useAppSelector((state) => state.connections.recentResources)
  const hasRecentDatasets = recentDatasets.length > 0
  const hasConnections = (connections ?? []).length > 0

  return (
    <BasicPage contentClassName="fullWidth">
      <BasicPageContainer>
        <HomeOnboardingWelcome />
        <HomeApps />

        <OnboardingInitialDialog
          type={Video.WORKSPACE}
          open={showInitialDialog}
          onWatchVideo={hideInitialDialog}
          onSkip={hideInitialDialog}
        />

        {isAvailable ? (
          <HomeGettingStarted />
        ) : (
          <HomeGettingStartedNoCDW
            hasConnections={hasConnections}
            hasMaps={hasMaps}
            latestMaps={latestMaps || []}
            hasWorkflows={hasWorkflows}
            latestWorkflows={latestWorkflows || []}
          />
        )}

        {hasRecentDatasets && <HomeDatasets />}

        <HomeBlogLatestPosts />
      </BasicPageContainer>
    </BasicPage>
  )
}

export default HomeOnboarding
